import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'

export class EndlessSlider {
  constructor() {
    this.sliders = document.querySelectorAll('.js-endless-slider')
    if (!this.sliders) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.swiper.autoplay.start()
          } else {
            entry.target.swiper.autoplay.stop()
          }
        })
      },
      { root: null, threshold: 0, rootMargin: `0px 0px` }
    )

    window.addEventListener('load', () => {
      this.initSwiper()
    })
  }
  initSwiper() {
    this.sliders.forEach((slider) => {
      const slidesPerViewAttr = slider.getAttribute('data-slidesperview')
      const option = {
        speed: slider.getAttribute('data-speed') || 30000,
        autoplayDirection: slider.classList.contains('-reverse') || false,
        spaceBetween: parseInt(slider.getAttribute('data-spacebetween')) || 0,
        slidesPerView: slidesPerViewAttr ? (slidesPerViewAttr === 'auto' ? 'auto' : parseFloat(slidesPerViewAttr)) : 'auto',
        breakpoints: {},
      }

      const breakpointsAttr = slider.getAttribute('data-breakpoints')
      if (breakpointsAttr) {
        try {
          option.breakpoints = JSON.parse(breakpointsAttr)
        } catch (e) {
          console.warn('Invalid JSON in data-breakpoints:', e)
        }
      }

      this.cloneSlide(slider)

      const swiper = new Swiper(slider, {
        modules: [Autoplay],
        autoplay: {
          delay: 0,
          reverseDirection: option.autoplayDirection,
        },
        loop: true,
        speed: option.speed,
        slidesPerView: 'auto',
        allowTouchMove: false,
        breakpoints: option.breakpoints,
        spaceBetween: option.spaceBetween,
      })

      this.observer.observe(swiper.el)
    })
  }

  cloneSlide(slider) {
    const slides = slider.querySelectorAll('.swiper-slide')
    slides.forEach(function (slide) {
      const cloneSlide = slide.cloneNode(true)
      slider.querySelector('.swiper-wrapper').appendChild(cloneSlide)
    })
  }
}
